import { http as axios } from "./axios";

class BenchmarkingService {
  filters(filters, user = null) {
    return axios.get(`benchmarking/filters`, {
      params: { ...filters, user_id: user },
    });
  }
  // eslint-disable-next-line no-unused-vars
  scores(filters, user = null, fetch_own = false) {
    const all = axios.get(`benchmarking/scores`, {
      params: { ...filters },
    });

    /*if (!fetch_own) {
      return Promise.all([all]);
    }*/

    const own = axios.get(`benchmarking/own_scores`, {
      params: { ...filters, user_id: user },
    });

    return Promise.all([all, own]);
  }
}

export default new BenchmarkingService();
